import Layout from "@/layout/index.vue";

export default [
  // 客户管理
  {
    path: "/customer",
    name: "customer",
    component: Layout,
    redirect: "/customer/complaint-detail",
    meta: {
      title: "客户管理",
    },
    children: [
      {
        path: "/customer/complaint-meta",
        name: "customerComplaintMeta",
        component: () =>
          import("@/views/customer/pages/complaint-detail/meta.vue"),
        meta: {
          title: "客户信息",
          newPage: true,
        },
      },
      {
        path: "/customer/complaint-detail",
        name: "customerComplaintDetail",
        component: () =>
          import("@/views/customer/pages/complaint-detail/index.vue"),
        meta: {
          title: "客户详情",
          newPage: true,
        },
      },
      {
        path: "/customer/black-list",
        name: "customerBlackList",
        component: () => import("@/views/customer/pages/black-list/index.vue"),
        meta: {
          title: "黑名单管理",
          newPage: true,
        },
      },
      {
        path: "/customer/seat-bind-gzh",
        name: "customerSeatBindGzh",
        component: () => import("@/views/customer/pages/seat-bind-gzh/index.vue"),
        meta: {
          title: "公众号绑定",
          newPage: true,
        },
      },
      {
        path: "/customer/gzh-message",
        name: "customerGzhMessage",
        component: () => import("@/views/customer/pages/gzh-message/index.vue"),
        meta: {
          title: "公众号消息",
          newPage: true,
        },
      },
      {
        path: "/customer/qw-chat",
        name: "customerQwChat",
        component: () => import("@/views/customer/pages/qw-chat/index.vue"),
        meta: {
          title: "企微消息",
          newPage: true,
        },
      },
      {
        path: "/customer/work-order-list",
        name: "customerWorkOrderList",
        component: () =>
          import("@/views/customer/pages/work-order-list/index.vue"),
        meta: {
          title: "投诉工单管理",
          newPage: true,
        },
      },
      {
        path: "/customer/sensitive-data-operate",
        name: "customerSensitiveDataOperate",
        component: () =>
          import("@/views/customer/pages/sensitive-data-operate/index.vue"),
        meta: {
          title: "敏感信息转码",
          newPage: true,
        },
      },
      {
        path: "/customer/refund-fail-user",
        name: "customeRrefundFailUser",
        component: () =>
          import("@/views/customer/pages/refund-fail-user/index.vue"),
        meta: {
          title: "退款失败用户",
          newPage: true,
        },
      },
    ],
  },
  // 公众号管理
  {
    path: "/wechat",
    name: "wechat",
    component: Layout,
    redirect: "/customer/complaint-detail",
    meta: {
      title: "公众号管理",
      icon: "el-icon-menu",
    },
    children: [
      {
        path: "/wechat/wait-unbind-user-list",
        name: "wechatWaitUnbindUserList",
        component: () =>
          import("@/views/wechat/pages/wait-unbind-user-list/index.vue"),
        meta: {
          title: "等待解绑用户列表",
          newPage: true,
        },
      },
    ],
  },
  {
    path: "/zzd",
    name: "Zzd",
    component: Layout,
    redirect: "/surrender_management",
    meta: {
      title: "赠转短",
    },
    children: [
      {
        path: "/surrender_management",
        name: "surrender_management",
        component: () => import("@/views/page/zzd/surrenderManagement.vue"),
        meta: {
          title: "退保管理",
        },
      },
    ],
  },
]
